/**
 * Does this `Content-Type` mean the body will be parsed as JSON?
 *
 * ONE predicate, because two of them disagreed and the gap was silent. `useApi`
 * parses only when the header contains `application/json`; the GEX hook decided
 * a response was "not silent" whenever the header contained `json` at all. A
 * media type in between — `application/problem+json`, `application/hal+json`,
 * or a vendor `application/vnd.x+json` — was therefore routed to the TEXT branch
 * by the parser and simultaneously judged a successful JSON answer by the hook.
 * The result is a 200 with no data, no retry, and no report: exactly the
 * silent-failure shape both mechanisms exist to catch.
 *
 * The rule matches what `useApi` actually does, since the parser is the one that
 * decides whether `data` gets set. Suffix types are deliberately EXCLUDED rather
 * than added: widening the parser is a behaviour change to every caller, while
 * narrowing the detector only means those responses are correctly treated as
 * silent. If we later teach the parser `+json`, this is the single place both
 * sides move together.
 */
export function isJsonMediaType(contentType: string | null | undefined): boolean {
  return !!contentType && contentType.toLowerCase().includes('application/json');
}
